<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="HelpDeskTechnicianRequestView"
      navigationField="displayID"
      :selectionEnabled="true"
      :onLoaded="mapResults"
    ></dx-grid>

    <v-dialog persistent v-model="mapUsersDialog" max-width="500">
      <v-card class="pa-3">
        <v-layout row>
          <v-card-title class="headline pl-0 pt-0 pb-2">Map Users</v-card-title>
          <v-spacer></v-spacer>
        </v-layout>

        <!--   <div v-if="!usersToMap.length" class="text-danger title">
                    Please select tickets with unmapped users
                </div> -->
        <div style="overflow-y: auto; height: 300px">
          <div v-for="(userToMap, index) in usersToMap">
            <v-layout row>
              <div class="font-weight-medium width-220 pt-4 mr-2">
                {{
                  userToMap.requesterEmail
                    ? `${userToMap.name} - ${userToMap.requesterEmail}`
                    : userToMap.name
                }}
              </div>
              <v-autocomplete
                class="my-2"
                hide-details
                label="User"
                placeholder="Start typing..."
                hide-no-data
                ref="selectedUser"
                v-model="userToMap.selectedUser"
                :items="users"
              ></v-autocomplete>
            </v-layout>
            <v-divider
              class="my-2"
              v-if="index + 1 < usersToMap.length"
            ></v-divider>
          </div>
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="mapUsersDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            :disabled="!usersToMap.length"
            @click="saveMappedUsers()"
          >
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="mappedUsersDialog" max-width="700">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Mapped Users ({{ manageengineUsers.length }})<small
            class="text--secondary ml-3"
            >Search by Ctrl+F</small
          ></v-card-title
        >
        <strong>
          Map Portal users to ManageEngine emails or user IDs. Current mappings
          are shown below.
        </strong>
        <br />
        <v-btn small color="success" dark @click="openNewMapUserDialog"
          >new map</v-btn
        >
        <v-btn
          small
          color="success"
          v-if="manageengineUsers.filter((m) => m.selected).length"
          @click="openConfirmDeleteUserDialog"
          >Delete selected User/s
        </v-btn>
        <v-dialog persistent v-model="newMapUser.dialog" max-width="350">
          <v-card class="pa-4">
            <v-form ref="newMapUserForm">
              <v-layout row>
                <v-card-title class="headline pl-0 pt-0 pb-2"
                  >Map new user {{
                }}</v-card-title>
              </v-layout>

              <div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <v-autocomplete
                    class="my-2"
                    hide-details
                    label="User"
                    placeholder="Start typing..."
                    hide-no-data
                    v-model="newMapUser.selectedUser"
                    :items="users"
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </div>
              </div>
              <v-select
                v-model="newMapUser.mapSelection"
                label="Map user by"
                :items="['Email', 'User ID']"
                @change="(newMapUser.email = ''), (newMapUser.userID = '')"
              ></v-select>
              <v-text-field
                v-if="newMapUser.mapSelection === 'Email'"
                v-model="newMapUser.email"
                label="Email"
                placeholder="Enter a full valid ManageEngine email"
                outlined
                :rules="[rules.optionalEmail]"
              />

              <v-text-field
                v-if="newMapUser.mapSelection === 'User ID'"
                v-model="newMapUser.userID"
                label="ID"
                placeholder="Enter a full ManageEngine user ID"
                outlined
                :rules="[rules.userID]"
              >
                <template v-slot:prepend>
                  <v-icon
                    color="red"
                    class="cursor-pointer blink"
                    @click="showIDAlert()"
                  >
                    mdi-exclamation
                  </v-icon>
                </template>
              </v-text-field>
              <p
                v-if="
                  this.newMapUser.selectedUser &&
                    (this.newMapUser.email || this.newMapUser.userID)
                "
                class="font-weight-bold"
                style="font-size: 0.75rem;"
              >
                {{
                  this.newMapUser.email
                    ? `Email "${this.newMapUser.email}"`
                    : ""
                }}
                {{
                  this.newMapUser.userID
                    ? `User ID "${this.newMapUser.userID}"`
                    : ""
                }}
                will mapped to Portal user "{{ this.newMapUser.selectedUser }}"
              </p>
              <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
                <v-spacer></v-spacer>

                <v-btn color="default" dark @click="resetNewMapUser()"
                  >Cancel</v-btn
                >
                <v-btn
                  :loading="processing"
                  color="success"
                  @click="saveNewMapUser()"
                  :disabled="!this.newMapUser.email && !this.newMapUser.userID"
                >
                  save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog persistent v-model="confirmDeleteUserDialog" max-width="400">
          <v-card class="pa-3">
            <v-card-title class="headline pl-0 pt-0"
              >Delete Mapped Users</v-card-title
            >

            <div class="font-weight-medium">
              The
              {{ manageengineUsers.filter((m) => m.selected).length }}
              selected users will be deleted
            </div>

            <v-card-actions class="mr-0 mt-3 pb-0">
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                dark
                @click="confirmDeleteUserDialog = false"
                >Cancel</v-btn
              >
              <v-btn
                :loading="processing"
                color="success"
                @click="deleteUsers()"
              >
                delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="IDAlertDialog" max-width="600">
          <v-card class="pa-3">
            <v-card-title class="headline pl-0 pt-0">
              Map User ID Alert
            </v-card-title>
            <strong>
              The best way to map is by email. Use this option only when there
              is no requester email.
              <br />
              <div v-if="this.newMapUser.dialog">
                <span style="color: red;"
                  >Don’t create duplicate mappings!</span
                >
                <br />
                If an email is already linked to a user, don’t map the same
                request again using the user ID. Otherwise, each request will
                appear twice. If you map a email to one user and his user ID to
                a different user, both users will see the request.
              </div>
            </strong>
            <v-card-text>
              To map by ID, make sure you are using the correct ID.<br />
              Open the ticket on
              <a
                href="https://utaw.sdpondemand.manageengine.com"
                target="_blank"
                >utaw.sdpondemand.manageengine.com</a
              >.<br />
              Open the browser console (F12 → Console) and run:<br />
              <code
                >document.querySelector('.requester-link-card').querySelector('a').getAttribute('onclick').split(`'`)[1] </code
              ><br />
              <br />
              Optional: Create a bookmarklet with:<br />
              <code
                >javascript:(function(){alert(document.querySelector('.requester-link-card').querySelector('a').getAttribute('onclick').split(`'`)[1]);})();</code
              ><br />
              Than when you on a ticket Click the bookmark to see the requester
              ID.
            </v-card-text>

            <v-card-actions class="mr-0 mt-3 pb-0">
              <v-spacer></v-spacer>
              <v-btn color="success" dark @click="IDAlertDialog = false">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-layout row justify-start>
          <div class="width-25 mr-2"></div>
          <div class="pt-1 font-weight-medium width-220">
            Portal Username
          </div>
          <div class="pt-1 font-weight-medium width-220">
            ManageEngine User Info
          </div>
          <v-spacer></v-spacer>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <div style="overflow-y: auto; height: 400px">
          <div v-for="(manageengineUser, index) in manageengineUsers">
            <v-layout row justify-start>
              <v-checkbox
                v-model="manageengineUser.selected"
                class="my-0 mr-2 width-25"
                color="success"
                hide-details
              ></v-checkbox>
              <div class="pt-1 width-220">
                {{ manageengineUser.username }}
              </div>
              <div class="pt-1">
                <template v-if="manageengineUser.requesterEmail">
                  <b>Email:</b>
                  {{ manageengineUser.requesterEmail }}
                </template>
                <template v-else>
                  <b>User ID:</b>
                  {{ manageengineUser.requesterID }}
                </template>
              </div>

              <v-spacer></v-spacer>
            </v-layout>
            <v-divider
              class="my-2"
              v-if="index + 1 < manageengineUsers.length"
            ></v-divider>
          </div>
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="mappedUsersDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <create-ticket-by-tech
      v-model="newTicketTech"
      @newTicketSended="reloadGrid()"
    />
    <m-e-users-contact-mapping-dialog v-model="MEContactMappingDialog" />
  </div>
</template>

<script>
import MEUsersContactMappingDialog from "./MEUsersContactMappingDialog.vue";
import CreateTicketByTech from "./CreateTicketByTech.vue";
export default {
  components: {
    CreateTicketByTech,
    MEUsersContactMappingDialog,
  },
  data: () => ({
    cancelBtnAbility: false,
    sendBtnDisability: false,
    title: "Support Tickets",
    url: "",
    techniciansOnTickets: [],
    actions: [],

    processing: false,

    includeClosed: false,
    filterForTechnician: "",
    includeTechsWithClosedOnly: false,

    mapUsersDialog: false,
    mappedUsersDialog: false,

    confirmDeleteUserDialog: false,

    selectedUser: "",
    usersToMap: [],
    users: [],
    manageengineUsers: [],

    newMapUser: {
      dialog: false,
      selectedUser: null,
      email: "",
      userID: "",
      mapSelection: "Email",
    },

    newTicketTech: false,
    MEContactMappingDialog: false,

    IDAlertDialog: false,

    rules: {
      required: (value) => !!value || "Required.",
      email: (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Enter a valid email",
      optionalEmail: (value) => {
        if (!value) return true;
        return (
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          ) || "Enter a valid email or remove."
        );
      },
      userID: (value) => {
        if (!value) return true;
        return (
          /^\d{17}$/.test(value) ||
          "Enter a valid manageengine user ID or remove."
        );
      },
    },

    columns: [
      {
        field: "priority",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          return "mdi-box-shadow";
        },
        iconColor: (value) => {
          switch (value) {
            case "1 High":
            case "3 Option 8":
              return "#e74c3c";
            case "2 Normal":
              return "#f39c12";
            case "4 Low":
              return "#7f8c8d";
            default:
              return "#bdc3c7";
          }
        },
      },
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Closed":
              return "mdi-check-circle";
            case "Open":
            case "Reopened":
              return "mdi-clock";
            case "On Hold":
              return "mdi-clock";
            case "Canceled":
              return "mdi-cancel";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Closed":
              return "#2ecc71";
            case "Open":
            case "Reopened":
              return "#f1c40f";
            case "On Hold":
              return "#3498db";
            case "Canceled":
              return "#e74c3c";
            default:
              return "#bdc3c7";
          }
        },
      },
      // {
      //     label: "Status",
      //     field: "statusName",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Ticket Number",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskTechnicianRequestView",
        template: "link-cell-template",
        cssClass: "width-100",
      },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Requester Email",
        field: "requesterEmail",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-200",
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByTimeDateTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ETA",
        field: "dueByTimeValue",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "text-color-cell-template",
      },
      {
        label: "Last Sync Time",
        field: "lastSyncTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "User",
        field: "username",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "siteName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "departmentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Technician Email",
      //     field: "technicianEmail",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
    ],
  }),
  watch: {
    // async loadUsers(value) {
    //     if (!value) return;
    //     const response = await this.$http.get(
    //         `/odata/users?$count=true&$filter=(contains(userName, '${value.trim()}'))`,
    //     );
    //     this.users = response.value.map((u) => u.userName);
    // },
  },
  async created() {},

  methods: {
    async beforeSetupGrid() {
      await this.getTechniciansOnTickets();
      console.log(this.includeTechsWithClosedOnly);
      this.columns.find((c) => c.field == "dueByTimeValue").getTextColor = (
        value
      ) => {
        if (!value) return;
        if (value.startsWith("In")) {
          return "blue";
        } else {
          return "red";
        }
      };

      this.url = `manageengine?includeClosed=${
        this.includeClosed
      }&filterForUser=false&filterForTechnician`;

      if (this.$route.query.showClosed) {
        this.includeClosed = true;
      }

      this.actions.push({
        text: "Show Closed",
        type: "switch",
        align: "left",
        value: this.includeClosed,
        action: this.onShowClosedChanged,
      });

      // this.actions.push({
      //   text: "Filter for " + this.$store.state.authentication.user,
      //   type: "switch",
      //   align: "left",
      //   value: this.filterForUser,
      //   action: this.onUserFilterChanged,
      // });

      this.actions.push({
        text: "Select Techician",
        values: this.techniciansOnTickets,
        type: "select",
        onSelected: this.onTechSelected,
      });

      this.actions.push({
        text: "New Ticket Tech",
        action: this.openNewTicketTech,
      });

      this.actions.push({
        text: "Sync open Tickets",
        action: this.syncOpenTickets,
      });

      this.actions.push({
        text: "Map Users",
        action: this.openMapUsers,
        showOnSelection: true,
      });

      this.actions.push({
        text: "Mapped Users",
        action: this.openMappedUsersDialog,
      });

      this.actions.push({
        text: "Extension / Phone Mapping",
        action: this.openMEContactMappingDialog,
      });

      if (this.$route.query.openNewTicket) {
        this.openNewTicketTech();
      }

      // this.loadUsers();
    },
    onShowClosedChanged(value) {
      this.includeClosed = value;
      this.url = `manageengine?includeClosed=${
        this.includeClosed
      }&filterForUser=false&filterForTechnician=${this.filterForTechnician}`;
      this.$refs.grid.reloadDataSource(this.url);
    },
    // onUserFilterChanged(value) {
    //   this.filterForUser = value;
    //   this.url =
    //     "manageengine?includeClosed=" +
    //     this.includeClosed +
    //     "&filterForUser=" +
    //     value;
    //   this.$refs.grid.reloadDataSource(this.url);
    // },

    async loadUsers() {
      const response = await this.$http.get(`/odata/users?$count=true`);
      this.users = response.value.map((u) => u.userName);
    },

    // isTechnician() {
    //   const roles = this.$store.getters["authentication/getRoles"];
    //   const isTech = roles.includes("Technician");
    //   return isTech;
    // },

    async openMapUsers() {
      const selected = this.$refs.grid.getSelectedRowsData();
      if (!selected.filter((t) => t.username == "UNMAPPED USER").length) {
        alert("Please select tickets with unmapped users");
        return;
      }
      await this.loadUsers();

      this.usersToMap = selected
        .filter((t) => t.username == "UNMAPPED USER")
        .map((t) => ({
          requesterEmail: t.requesterEmail,
          requesterID: t.requesterID,
          requesterName: t.name,
        }))
        .filter(
          (v, i, a) =>
            a.findIndex(
              (x) =>
                x.requesterEmail === v.requesterEmail &&
                x.requesterID === v.requesterID
            ) === i
        )
        .map((t) => ({
          requesterEmail: t.requesterEmail,
          requesterID: t.requesterID,
          name: t.requesterName,
          selectedUser: "",
        }));
      this.mapUsersDialog = true;
    },

    async openMappedUsersDialog() {
      await this.loadManageengineUsers();
      this.mappedUsersDialog = true;
    },
    async loadManageengineUsers() {
      const response = await this.$http.get(
        "api/manageengine/getManageengineMappedUsers"
      );

      this.manageengineUsers = response.map((user) => {
        user.selected = false;
        return user;
      });
    },

    async openNewMapUserDialog() {
      this.newMapUser.dialog = true;
      await this.loadUsers();
    },
    openConfirmDeleteUserDialog() {
      this.confirmDeleteUserDialog = true;
    },

    openNewTicketTech() {
      this.newTicketTech = true;
    },
    openMEContactMappingDialog() {
      this.MEContactMappingDialog = true;
    },

    async saveNewMapUser() {
      if (!this.$refs.newMapUserForm.validate(true)) {
        return;
      }

      const existID = this.manageengineUsers.find(
        (u) => u.requesterID == this.newMapUser.userID
      );
      if (existID && this.newMapUser.userID) {
        alert(
          existID.requesterID + " is already mapped to " + existID.username
        );
        return;
      }

      const existEmail = this.manageengineUsers.find(
        (u) =>
          u.requesterEmail &&
          this.newMapUser.email &&
          u.requesterEmail.toLowerCase() == this.newMapUser.email.toLowerCase()
      );

      if (existEmail && this.newMapUser.email) {
        alert(
          existEmail.requesterEmail +
            " is already mapped to " +
            existEmail.username
        );
        return;
      }
      const existUser = this.manageengineUsers.find(
        (u) =>
          u.username &&
          this.newMapUser.email &&
          u.username.toLowerCase() == this.newMapUser.email.toLowerCase()
      );
      if (existUser) {
        const existUserConfirm = confirm(
          this.newMapUser.email +
            " is a portal username. If you map the user this way, they will not see their requests—only user " +
            this.newMapUser.selectedUser +
            " will be able to view them"
        );
        if (!existUserConfirm) return;
      }
      this.processing = true;
      try {
        await this.$http.post(
          `api/manageengine/NewMapUser?user=${
            this.newMapUser.selectedUser
          }&email=${this.newMapUser.email}&userID=${this.newMapUser.userID}`
        );
        this.loadManageengineUsers();
        this.resetNewMapUser();
        this.$refs.grid.reloadGrid();
        this.processing = false;
        this.$notify({
          group: "notification",
          text: "Mappet user Saved",
          type: "success",
        });
      } catch {
        this.processing = false;
      }
    },

    async saveMappedUsers() {
      if (this.usersToMap.every((u) => !u.selectedUser)) {
        return this.$notify({
          group: "notification",
          text: "No user selected",
          type: "error",
        });
      }

      try {
        this.processing = true;
        await this.$http.post(
          "api/manageengine/saveManageengineMappedUsers",
          this.usersToMap
            .filter((u) => u.selectedUser)
            .map((user) => ({
              username: user.selectedUser,
              requesterEmail: user.requesterEmail,
              requesterID: user.requesterID,
              // matchedBy: this.$store.state.authentication.user,
            }))
        );

        this.processing = false;
        this.mapUsersDialog = false;

        this.$refs.grid.reloadGrid();

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });
      } catch (e) {
        this.processing = false;
      }
    },
    async deleteUsers() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/manageengine/DeleteManageengineUsers",
          this.manageengineUsers
            .filter((u) => u.selected)
            .map((user) => user.id)
        );

        this.processing = false;
        this.confirmDeleteUserDialog = false;

        this.loadManageengineUsers();
        this.$refs.grid.reloadGrid();
        this.$notify({
          group: "notification",
          text: "Mapped Users Deleted",
          type: "success",
        });
      } catch (e) {
        this.processing = false;
      }
    },

    resetNewMapUser() {
      this.processing = false;
      this.newMapUser.dialog = false;
      this.$refs.newMapUserForm.resetValidation(true);
      this.newMapUser.selectedUser = null;
      this.newMapUser.email = null;
      this.newMapUser.userID = null;
      this.newMapUser.mapSelection = "Email";
    },
    showIDAlert() {
      this.IDAlertDialog = true;
    },
    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },
    async getTechniciansOnTickets() {
      const response = await this.$http.get(
        `api/manageengine/getTechniciansOnTickets?includeClosed=${
          this.includeTechsWithClosedOnly
        }`
      );
      this.techniciansOnTickets = [
        { text: "All Technicians", value: "" },
        { text: "Unassigned", value: "Unassigned" },
        ...response.map((tech) => ({ text: tech, value: tech })),
      ];
    },
    onTechSelected(value) {
      if (!value) {
        this.url = `manageengine?includeClosed=${
          this.includeClosed
        }&filterForUser=false&filterForTechnician`;
      } else {
        this.filterForTechnician = value;
        this.url = `manageengine?includeClosed=${
          this.includeClosed
        }&filterForUser=false&filterForTechnician=${value}`;
      }
      this.$refs.grid.reloadDataSource(this.url);
    },

    mapResults(results) {
      results.map((t) => {
        t.technicianName =
          t.technicianName == "UserPortal" ? "" : t.technicianName;
        if (t.statusName != "Closed") {
          t.dueByTimeValue = this.getDueBy(t.dueByTimeValue);
        } else {
          t.dueByTimeValue = null;
        }
        return t;
      });
    },

    getDueBy(dueByTimeValue) {
      if (!dueByTimeValue) return null;
      const currentTime = new Date().getTime();

      const distance = dueByTimeValue - currentTime;

      const absDistance = Math.abs(distance);
      const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (absDistance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

      const timeStr = `${days ? days + " days" : ""} ${
        hours ? hours + " hours" : ""
      }  ${minutes} minutes`;

      if (distance >= 0) {
        return `In ${timeStr}`;
      } else {
        return `Delay by ${timeStr}`;
      }
    },
    async syncOpenTickets() {
      try {
        await this.$http.post(`api/manageengine/UpdateOpenTickets`);
        this.reloadGrid();
        this.$notify({
          text: "Open Tickets Syncked",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
